///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, ViewContainerRef } from '@angular/core';
import { GtthValidationMessageComponent } from './validation-message.component';

@Directive({
    selector: '[windeEntityNameValidation]'
})
export class GtthEntityNameValidationDirective implements OnChanges, OnInit, OnDestroy {
    @Input() inputVal: string;
    @Input() cutPattern: string;
    @Input() showValidationText: boolean;
    @Input() inputIsRequired: boolean;

    @Output() inputValChange: EventEmitter<string> = new EventEmitter<string>();

    private readonly validationRule = /[^a-z\d\s_\-=+*\\|/?!@#$%^&()[\]{}~.,><]/gi;
    private customValidationRule;
    private isRequired: boolean;
    private validationMessageComponentRef;
    private message: string;
    private showMessage: boolean;
    private validateTimeout;

    constructor(
        private readonly el: ElementRef,
        private readonly viewContainerRef: ViewContainerRef
    ) {}

    ngOnChanges() {
        if (this.validateTimeout) {
            clearTimeout(this.validateTimeout);
        }
        this.validateTimeout = setTimeout(() => {
            this.validate();
            this.inputValChange.emit(this.inputVal);
        }, 0);
    }

    ngOnInit() {
        if (this.cutPattern) {
            this.customValidationRule = new RegExp(this.cutPattern, 'gi');
        }
        this.isRequired = this.el.nativeElement.required;
        this.addValidationMessageComponent();
    }

    ngOnDestroy() {
        if (this.validateTimeout) {
            clearTimeout(this.validateTimeout);
            this.validateTimeout = undefined;
        }
    }

    private validate() {
        if (this.inputVal) {
            this.inputVal = this.inputVal.replace(/^\s/g, '').replace(/\s{2,}/g, ' ');
            if (this.customValidationRule) {
                this.inputVal = this.inputVal.replace(this.customValidationRule, '');
            } else {
                this.inputVal = this.inputVal.replace(this.validationRule, '');
            }
        }

        this.setValidationMessage();
    }

    private addValidationMessageComponent() {
        this.viewContainerRef.clear();
        this.validationMessageComponentRef = this.viewContainerRef.createComponent(GtthValidationMessageComponent);
    }

    private setValidationMessage() {
        if (!this.validationMessageComponentRef) {
            return;
        }
        if (this.showValidationText) {
            this.showMessage = this.showValidationText;
        }
        if (this.showMessage) {
            if ((this.inputVal === undefined || this.inputVal === '') && (this.isRequired || this.inputIsRequired)) {
                this.message = 'Field is required';
            } else {
                this.message = '';
            }
            (this.validationMessageComponentRef.instance as GtthValidationMessageComponent).message = this.message;
        }
    }
}
